<template>
  <events-list
      v-if="events"
      :is-loading="isLoading"
      :payment-notifications="events"
      :img-no="imgNo"
  ></events-list>
</template>
<script>

import EventsList from '@/components/Events/EventsList';

export default {
  components: { EventsList },
  data() {
    return {
      events: [],
      isLoading: true,
      imgNo: false,
    };
  },
  methods:
      {
        async loadNotifications() {
          try {
            this.isLoading = true;
            this.paymentNotifications = await this.getPaymentNotifications();
            this.isLoading = false;
          } catch (err) {
            this.imgNo = true;
            this.isLoading = false;
          }
        },
      },
  created() {
    this.loadNotifications();
  },

};
</script>
